const CryptoJS = require("crypto-js");

const encryptReactPassword = process.env.REACT_APP_ENCRYPT_PASSWORD || "pimptupEncryption";

const encryptEmail = (email) => {
    if (!email) return null;
    return CryptoJS.AES.encrypt(email, encryptReactPassword).toString();
};

const encryptPassword = (password) => {
    if (!password) return null;
    return CryptoJS.AES.encrypt(password, encryptReactPassword).toString();
};

const decryptEmail = (cipherText) => {
    try {
        if (!cipherText) return null;
        const bytes = CryptoJS.AES.decrypt(cipherText, encryptReactPassword);
        const originalText = bytes.toString(CryptoJS.enc.Utf8);
        return originalText || null;
    } catch (error) {
        console.error("Decrypt email failed:", error);
        return null;
    }
};

const decryptPassword = (cipherText) => {
    try {
        if (!cipherText) return null;
        const bytes = CryptoJS.AES.decrypt(cipherText, encryptReactPassword);
        const originalText = bytes.toString(CryptoJS.enc.Utf8);
        return originalText || null;
    } catch (error) {
        console.error("Decrypt password failed:", error);
        return null;
    }
};

export default { encryptEmail, encryptPassword, decryptEmail, decryptPassword };
